<template>
  <div class="chat-input-area">
    <!-- 添加 dragover 和 drop 事件监听 -->
    <div :class="['edit-container', isEmpty ? '' : 'not-empty']"
         contenteditable="true"
         @paste.prevent="onPaste"
         @keydown="onKeydown"
         @compositionstart="compositionFlag = true"
         @compositionend="onCompositionEnd"
         @input="onEditorInput"
         @mousedown="onMousedown"
         ref="content"
         @blur="onBlur"
         @dragover.prevent="onDragOver"
         @drop.prevent="onDrop">
    </div>
    <chat-at-box @select="onAtSelect" :search-text="atSearchText" ref="atBox" :group="group"
                 :members="groupMembers"></chat-at-box>
  </div>
</template>

<script>
import ChatAtBox from "./ChatAtBox";

export default {
  name: "ChatInput",
  components: { ChatAtBox },
  props: {
    chatId: {
      type: [String, Number],
      required: true
    },
    group: {
      type: Object,
    },
    groupMembers: {
      type: Array,
    },
  },
  data() {
    return {
      imageList: {},   // 改成对象
      fileList: {},
      currentId: 0,
      atSearchText: null,
      compositionFlag: false,
      atIng: false,
      isEmpty: true,
      changeStored: true,
      blurRange: null,
      inputCache: {} // 缓存每个聊天的输入内容
    }
  },
  methods: {
    onDragOver(e) {
      // 阻止默认行为，允许放置
      e.preventDefault();
    },
    onDrop(e) {
      // 阻止默认行为
      e.preventDefault();

      const files = e.dataTransfer.files;
      if (files.length === 0) return;

      this.isEmpty = false;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (file.type.startsWith('image/')) {
          // 处理图片文件
          this.handleDroppedImage(file);
        } else {
          // 处理其他文件
          this.handleDroppedFile(file);
        }
      }
    },

    handleDroppedImage(file) {
      const imagePush = {
        fileId: this.generateId(),
        file: file,
        url: URL.createObjectURL(file)
      };
      this.imageList[imagePush.fileId] = imagePush;

      const line = this.newLine();
      const imageElement = document.createElement('img');
      imageElement.className = 'chat-image no-text';
      imageElement.src = imagePush.url;
      imageElement.dataset.imgId = imagePush.fileId;
      line.appendChild(imageElement);

      const after = document.createTextNode('\u00A0');
      line.appendChild(after);
      this.selectElement(after, 1);
    },

    handleDroppedFile(file) {
      const filePush = { fileId: this.generateId(), file: file };
      this.fileList[filePush.fileId] = filePush;

      const line = this.newLine();
      const fileElement = this.createFile(filePush);
      line.appendChild(fileElement);

      const after = document.createTextNode('\u00A0');
      line.appendChild(after);
      this.selectElement(after, 1);
    },
    onPaste(e) {
      this.isEmpty = false;
      let txt = e.clipboardData.getData('Text')
      const range = this.getSafeRange();
      if (range.startContainer !== range.endContainer || range.startOffset !== range.endOffset) {
        range.deleteContents();
      }
      // 粘贴图片和文件时，这里没有数据
      if (txt && typeof (txt) == 'string') {
        let textNode = document.createTextNode(txt);
        range.insertNode(textNode)
        range.collapse();
        return;
      }
      let items = (e.clipboardData || window.clipboardData).items
      if (items.length) {
        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf('image') !== -1) {
            let file = items[i].getAsFile();
            let imagePush = {
              fileId: this.generateId(),
              file: file,
              url: URL.createObjectURL(file)
            };
            this.imageList[imagePush.fileId] = (imagePush);
            let line = this.newLine();
            let imageElement = document.createElement('img');
            imageElement.className = 'chat-image no-text';
            imageElement.src = imagePush.url;
            imageElement.dataset.imgId = imagePush.fileId;
            line.appendChild(imageElement);
            let after = document.createTextNode('\u00A0');
            line.appendChild(after);
            this.selectElement(after, 1);
          } else {
            let asFile = items[i].getAsFile();
            if (!asFile) {
              continue;
            }
            let filePush = { fileId: this.generateId(), file: asFile };
            this.fileList[filePush.fileId] = (filePush)
            let line = this.newLine();
            let fileElement = this.createFile(filePush);
            line.appendChild(fileElement);
            let after = document.createTextNode('\u00A0');
            line.appendChild(after);
            this.selectElement(after, 1);
          }
        }
      }
      range.collapse();
    },
    pasteScreenShot(buffer) {
      let id = this.generateId();
      let file = new File([buffer], 'screenShot-' + id + '.png', { type: "image/png" }); //type为图片的格式
      let imagePush = {
        fileId: id,
        file: file,
        url: URL.createObjectURL(file)
      };
      this.imageList[imagePush.fileId] = (imagePush);
      let line = this.newLine();
      let imageElement = document.createElement('img');
      imageElement.className = 'chat-image no-text';
      imageElement.src = imagePush.url;
      imageElement.dataset.imgId = imagePush.fileId;
      line.appendChild(imageElement);
      let after = document.createTextNode('\u00A0');
      line.appendChild(after);
      this.selectElement(after, 1);
    },
    selectElement(element, endOffset) {
      let selection = window.getSelection();
      // 插入元素可能不是立即执行的，vue可能会在插入元素后再更新dom
      this.$nextTick(() => {
        let t1 = document.createRange();
        try {
          // 确保偏移量不超过元素内容长度
          const maxOffset = element.textContent ? element.textContent.length : 0;
          const safeEndOffset = endOffset !== undefined ? Math.min(endOffset, maxOffset) : 0;

          t1.setStart(element, 0);
          t1.setEnd(element, safeEndOffset);

          if (element.firstChild) {
            t1.selectNodeContents(element.firstChild);
          }
          t1.collapse();
          selection.removeAllRanges();
          selection.addRange(t1);
          // 需要时自动聚焦
          if (element.focus) {
            element.focus();
          }
        } catch (e) {
          // fallback到简单的聚焦方法
          this.focus();
        }
      })
    },
    onCompositionEnd(e) {
      this.compositionFlag = false;
      this.onEditorInput(e);
    },
    onKeydown(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        e.stopPropagation();
        if (this.atIng) {
          this.$refs.atBox.select();
          return;
        }
        if (e.ctrlKey) {
          let line = this.newLine();
          let after = document.createTextNode('\u00A0');
          line.appendChild(after);
          this.selectElement(line.childNodes[0], 0);
        } else {
          // 中文输入标记
          if (this.compositionFlag) {
            return;
          }
          this.submit();
        }
        return;
      }
      // 删除键
      if (e.keyCode === 8) {
        // 等待dom更新
        setTimeout(() => {
          let s = this.$refs.content.innerHTML.trim();
          // 空dom时，需要刷新dom
          if (s === '' || s === '<br>' || s === '<div>&nbsp;</div>') {
            // 拼接随机长度的空格，以刷新dom
            this.empty();
            this.isEmpty = true;
            this.selectElement(this.$refs.content);
          } else {
            this.isEmpty = false;
          }
        })
      }
      // at框打开时，上下键移动特殊处理
      if (this.atIng) {
        if (e.keyCode === 38) {
          e.preventDefault();
          e.stopPropagation();
          this.$refs.atBox.moveUp();
        }
        if (e.keyCode === 40) {
          e.preventDefault();
          e.stopPropagation();
          this.$refs.atBox.moveDown();
        }
      }

    },
    onAtSelect(member) {
      this.atIng = false;

      // 获取或创建有效的range
      let blurRange = this.blurRange;

      // 如果blurRange不存在或无效，创建一个新的range
      if (!blurRange || !this.$refs.content.contains(blurRange.startContainer)) {
        this.focus();
        this.updateRange();
        blurRange = this.blurRange;

        // 如果仍然无效，创建range到外层div末尾
        if (!blurRange || !this.$refs.content.contains(blurRange.startContainer)) {
          const selection = window.getSelection();
          blurRange = document.createRange();

          // 检查外层div是否有子节点
          if (this.$refs.content.childNodes.length === 0) {
            // 外层div为空，直接在外层div中插入内容
            blurRange.selectNodeContents(this.$refs.content);
            blurRange.collapse(false);
          } else {
            // 外层div有子节点，找到最后一个有效节点
            let lastChild = this.$refs.content.lastChild;
            while (lastChild && lastChild.nodeType === 3 && lastChild.textContent.trim() === '') {
              lastChild = lastChild.previousSibling;
            }

            if (lastChild) {
              blurRange.setStartAfter(lastChild);
              blurRange.collapse(true);
            } else {
              blurRange.selectNodeContents(this.$refs.content);
              blurRange.collapse(false);
            }
          }

          selection.removeAllRanges();
          selection.addRange(blurRange);
          this.blurRange = blurRange;
        }
      }

      // 检查是否有@符号需要删除
      let startContainer = blurRange.startContainer;
      let startOffset = blurRange.startOffset;
      let hasAtSymbol = false;

      // 如果startContainer是文本节点，尝试查找@符号
      if (startContainer.nodeType === 3) {
        let textContent = startContainer.textContent;
        let atIndex = -1;

        // 从当前光标位置向前查找@符号
        if (startOffset > 0) {
          atIndex = textContent.lastIndexOf('@', startOffset - 1);
        }

        // 如果找到了@符号，并且后面跟着搜索文本，则删除这部分
        if (atIndex !== -1) {
          let searchText = this.atSearchText;
          if (textContent.substring(atIndex + 1, atIndex + 1 + searchText.length) === searchText) {
            // 删除从@符号到搜索文本结束的部分
            blurRange.setStart(startContainer, atIndex);
            blurRange.setEnd(startContainer, atIndex + 1 + searchText.length);
            blurRange.deleteContents();
            // 删除后，光标位置在删除内容的位置
            blurRange.collapse(true);
            hasAtSymbol = true;
          }
        }
      }

      // 确保输入框有焦点
      this.focus();

      // 创建@元素
      let element = document.createElement('SPAN');
      element.className = "chat-at-user";
      element.dataset.id = member.userId;
      element.contentEditable = 'false';
      element.innerText = `@${member.showNickName}`;

      // 插入@元素
      blurRange.insertNode(element);

      // 在@元素后面插入一个空格
      let spaceNode = document.createTextNode('\u00A0');
      blurRange.setStartAfter(element);
      blurRange.insertNode(spaceNode);

      // 将光标移动到空格后面
      blurRange.setStart(spaceNode, 1);
      blurRange.collapse(true);

      // 应用新的range
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(blurRange);

      this.atSearchText = "";
      this.isEmpty = false;
    }
    ,
    onEditorInput(e) {
      this.isEmpty = false;
      this.changeStored = false;
      if (this.$props.groupMembers && !this.compositionFlag) {
        const range = this.getSafeRange();
        // 截取@后面的名称作为过滤条件，并以空格结束
        let endContainer = range.endContainer;
        let endOffset = range.endOffset;
        let textContent = endContainer.textContent;
        let startIndex = -1;
        for (let i = endOffset; i >= 0; i--) {
          if (textContent[i] === '@') {
            startIndex = i;
            break;
          }
        }
        // 没有at符号，则关闭弹窗
        if (startIndex === -1) {
          this.$refs.atBox.close();
          return;
        }

        let endIndex = endOffset;
        for (let i = endOffset; i < textContent.length; i++) {
          if (textContent[i] === ' ') {
            endIndex = i;
            break;
          }
        }
        this.atSearchText = textContent.substring(startIndex + 1, endIndex).trim();
        // 打开选择弹窗
        if (this.atSearchText == '') {
          this.showAtBox(e)
        }
      }

    },
    onBlur() {
      if (!this.atIng) {
        // this.updateRange();
      }
    },
    onMousedown() {
      if (this.atIng) {
        this.$refs.atBox.close();
        this.atIng = false;
      }
    },
    insertEmoji(emojiText) {
      let emojiElement = document.createElement('img');
      emojiElement.className = 'emoji-normal no-text';
      emojiElement.dataset.emojiCode = emojiText;
      emojiElement.src = this.$emo.textToUrl(emojiText);

      let blurRange = this.blurRange;
      if (!blurRange) {
        this.focus();
        this.updateRange();
        blurRange = this.blurRange;
      }
      if (blurRange.startContainer !== blurRange.endContainer || blurRange.startOffset !== blurRange.endOffset) {
        blurRange.deleteContents();
      }
      blurRange.insertNode(emojiElement);
      blurRange.collapse()

      let textNode = document.createTextNode('\u00A0');
      blurRange.insertNode(textNode)
      blurRange.collapse()

      this.selectElement(textNode);
      // this.updateRange();
      this.isEmpty = false;
    },
    // 参考 insertEmoji 的实现方式
    insertText(text) {
      // 创建文本节点
      let textNode = document.createTextNode(text);

      // 获取当前光标位置（复用已有逻辑）
      let blurRange = this.blurRange;
      if (!blurRange) {
        this.focus();
        this.updateRange();
        blurRange = this.blurRange;
      }

      // 如果有选中文本则删除（复用已有逻辑）
      if (blurRange.startContainer !== blurRange.endContainer || blurRange.startOffset !== blurRange.endOffset) {
        blurRange.deleteContents();
      }

      // 插入文本节点
      blurRange.insertNode(textNode);
      blurRange.collapse();

      // 在文本后添加空格（与 insertEmoji 行为一致）
      let spaceNode = document.createTextNode('\u00A0');
      blurRange.insertNode(spaceNode);
      blurRange.collapse();

      // 更新光标位置（复用已有逻辑）
      this.selectElement(spaceNode);
      this.updateRange();
      this.isEmpty = false;
    },
    generateId() {
      return this.currentId++;
    },
    createFile(filePush) {
      let file = filePush.file;
      let fileId = filePush.fileId;
      let container = document.createElement('div');
      container.className = 'chat-file-container no-text';
      container.contentEditable = 'false';
      container.dataset.fileId = fileId;

      let left = document.createElement('div');
      left.className = 'file-position-left';
      container.appendChild(left);

      let icon = document.createElement('div');
      icon.className = 'el-icon-document';
      left.appendChild(icon);

      let right = document.createElement('div');
      right.className = 'file-position-right';
      container.appendChild(right);

      let fileName = document.createElement('div');
      fileName.className = 'file-name';
      fileName.innerText = file.name;

      let fileSize = document.createElement('div');
      fileSize.className = 'file-size';
      fileSize.innerText = this.sizeConvert(file.size);

      right.appendChild(fileName);
      right.appendChild(fileSize);

      return container;
    },
    sizeConvert(len) {
      if (len < 1024) {
        return len + 'B';
      } else if (len < 1024 * 1024) {
        return (len / 1024).toFixed(2) + 'KB';
      } else if (len < 1024 * 1024 * 1024) {
        return (len / 1024 / 1024).toFixed(2) + 'MB';
      } else {
        return (len / 1024 / 1024 / 1024).toFixed(2) + 'GB';
      }
    },
    updateRange() {
      this.blurRange = this.getSafeRange();
    },
    newLine() {
      const range = this.getSafeRange();
      let divElement = document.createElement('div');
      let endContainer = range.endContainer;
      let parentElement = endContainer.parentElement;
      if (parentElement.parentElement === this.$refs.content) {
        divElement.innerHTML = endContainer.textContent.substring(range.endOffset).trim();
        endContainer.textContent = endContainer.textContent.substring(0, range.endOffset);
        // 插入到当前div（当前行）后面
        parentElement.insertAdjacentElement('afterend', divElement);
      } else {
        divElement.innerHTML = '';
        this.$refs.content.append(divElement);
      }
      return divElement;
    },
    clear() {
      this.empty();
      this.imageList = [];
      this.fileList = [];
      this.$refs.atBox.close();
    },
    empty() {
      this.$refs.content.innerHTML = "";
      // // 直接在外层div中插入一个空格作为占位符
      // let after = document.createTextNode('\u00A0');
      // this.$refs.content.appendChild(after);
      // this.$nextTick(() => this.selectElement(after));
    },
    showAtBox(e) {
      this.atIng = true;
      // show之后会自动更新当前搜索的text
      // this.atSearchText = "";
      const range = this.getSafeRange();
      // 光标所在坐标
      let pos = range.getBoundingClientRect();
      this.$refs.atBox.open({
        x: pos.x,
        y: pos.y
      })
      // 记录光标所在位置
      this.updateRange();
    },
    submit() {
      let nodes = this.$refs.content.childNodes;
      let fullList = [];
      let tempText = '';
      let atUserIds = [];
      let each = (nodes) => {
        for (let i = 0; i < nodes.length; i++) {
          let node = nodes[i];
          if (!node) {
            continue;
          }
          if (node.nodeType === 3) {
            tempText += node.textContent;
            continue;
          }
          let nodeName = node.nodeName.toLowerCase();
          if (nodeName === 'script') {
            continue;
          }
          let text = tempText.trim();
          if (nodeName === 'img') {
            let imgId = node.dataset.imgId;
            if (imgId) {
              if (text) {
                fullList.push({
                  type: 'text',
                  content: text,
                  atUserIds: atUserIds
                })
                tempText = '';
                atUserIds = []
              }
              fullList.push({
                type: 'image',
                content: this.imageList[imgId]
              })
            } else {
              let emojiCode = node.dataset.emojiCode;
              tempText += emojiCode;
            }
          } else if (nodeName === 'div') {
            let fileId = node.dataset.fileId
            // 文件
            if (fileId) {
              if (text) {
                fullList.push({
                  type: 'text',
                  content: text,
                  atUserIds: atUserIds
                })
                tempText = '';
                atUserIds = []
              }
              fullList.push({
                type: 'file',
                content: this.fileList[fileId]
              })
            } else {
              tempText += '\n';
              each(node.childNodes);
            }
          } else if (nodeName === 'span') {
            if (node.dataset.id) {
              tempText += node.innerHTML;
              atUserIds.push(node.dataset.id)
            } else if (node.outerHtml) {
              tempText += node.outerHtml;
            }
          }
        }
      }
      each(nodes)
      let text = tempText.trim();
      if (text !== '') {
        fullList.push({
          type: 'text',
          content: text,
          atUserIds: atUserIds
        })
      }
      this.$emit('submit', fullList);
    },
    focus() {
      this.$refs.content.focus();
    },
    getInputContent() {
      // 返回包含HTML内容和相关文件数据的完整状态
      return {
        html: this.$refs.content.innerHTML,
        imageList: {...this.imageList},
        fileList: {...this.fileList},
        isEmpty: this.isEmpty
      };
    },
    getSafeRange() {
      const sel = window.getSelection();
      // 1. 如果当前焦点不在编辑区，先强制聚焦
      if (!this.$refs.content.contains(sel.anchorNode)) {
        this.focus();                       // 让编辑区获得焦点
      }
      // 2. 仍然没有 range 就创建一个
      if (sel.rangeCount === 0) {
        const newRange = document.createRange();
        newRange.selectNodeContents(this.$refs.content);
        newRange.collapse(false);           // 默认放到末尾
        sel.addRange(newRange);
      }
      return sel.getRangeAt(0);
    },
    setInputContent(data) {
      /* 1. 还原数据 */
      if (typeof data === 'string') {
        // 处理空内容的情况
        this.$refs.content.innerHTML = (data === '' || data === '\u00A0') ? '\u00A0' : data;
        this.isEmpty = !data || data === '' || data === '<div></div>' || data === '\u00A0';
        this.imageList = {};
        this.fileList   = {};
      } else {
        // 处理空内容的情况
        let htmlContent = data.html;
        if (htmlContent === '' || htmlContent === '\u00A0') {
          htmlContent = '';
        }
        this.$refs.content.innerHTML = htmlContent;
        this.isEmpty = data.isEmpty;
        this.imageList = { ...data.imageList };
        this.fileList   = { ...data.fileList };
      }

      /* 2. 等 DOM 真正渲染完 */
      this.$nextTick(() => {
        const content = this.$refs.content;

        /* 3. 强制让编辑区获得焦点，保证 selection 有效 */
        this.focus();

        /* 4. 新建一个 Range，直接移到末尾 */
        const range = document.createRange();
        range.selectNodeContents(content);
        range.collapse(false);          // false = 折叠到末尾

        /* 5. 应用 Range */
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);

        // 延迟再次设置焦点确保光标可见
        setTimeout(() => {
          content.focus();
          // 再次确保选区正确
          const sel = window.getSelection();
          if (sel.rangeCount === 0) {
            sel.addRange(range);
          }
        }, 10);
      });
    }
  },
  watch: {
    chatId: {
      immediate: true,
      handler(newId, oldVal) {          // 第二形参改个名
        // 保存旧聊天输入内容
        if (oldVal !== undefined) {
          this.inputCache[oldVal] = this.getInputContent();
        }
        // 恢复新聊天输入内容
        this.$nextTick(() => {
          const cached = this.inputCache[newId];   // 现在不会重名了
          if (cached) {
            this.setInputContent(cached);
          } else {
            this.clear();
          }
        });
      }
    }
  }
}
</script>

<style lang="scss">
.chat-input-area {
  width: 100%;
  height: 100%;
  position: relative;

  .edit-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    outline: none;
    padding: 5px;
    line-height: 26px;
    font-size: var(--im-font-size);
    text-align: left;
    overflow-y: auto;
    white-space: pre-wrap;

    // 单独一行时，无法在前面输入的bug
    >div:before {
      content: "\00a0";
      font-size: 14px;
      position: absolute;
      top: 0;
      left: 0;
    }

    .chat-image {
      display: block;
      max-width: 200px;
      max-height: 100px;
      border: 1px solid #e6e6e6;
      cursor: pointer;
    }

    .chat-file-container {
      max-width: 65%;
      padding: 10px;
      border: 2px solid #587ff0;
      display: flex;
      background: #eeeC;
      border-radius: 10px;

      .file-position-left {
        display: flex;
        width: 80px;
        justify-content: center;
        align-items: center;

        .el-icon-document {
          font-size: 40px;
          text-align: center;
          color: #d42e07;
        }
      }

      .file-position-right {
        flex: 1;

        .file-name {
          font-size: 16px;
          font-weight: 600;
          color: #66b1ff;
        }

        .file-size {
          font-size: 14px;
          font-weight: 600;
        }
      }
    }

    .chat-at-user {
      color: #00f;
      border-radius: 3px;
    }
  }

  .edit-container>div:nth-of-type(1):after {
    content: '请输入消息（按Ctrl+Enter键换行）';
    color: gray;
  }

  .edit-container.not-empty>div:nth-of-type(1):after {
    content: none;
  }
  .chat-input-area .edit-container.drag-over {
    background-color: #f0f8ff; /* 浅蓝色背景表示可以放置 */
    border: 2px dashed #007bff; /* 虚线边框 */
  }
}
</style>
